let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6p1JY")).then(() => parcelRequire('1iOv0'));